<nz-spin [nzSpinning]="loading$ | async">
  <form nz-form class="form" nzLayout="horizontal">
    <div class="drawer-form-wrapper">
      <div class="behaviour-card-sec" *ngIf="caseDetail && caseDetail.student">
        <div class="header-with-cta mb-24">
          <h3 class="title s-18">
            {{ caseDetail.student.firstName }} {{ caseDetail.student.lastName }}
          </h3>
        </div>
        <div class="card-content-wrapper">
          <div class="content">
            <h4 class="title">Date Of Birth</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"
                aria-label="Calendar"></svg-icon>
              {{ caseDetail.student.dateOfBirth | date: 'MM/dd/yyyy' }}
            </p>
          </div>
          <div class="content">
            <h4 class="title">Supervisor</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-supervisor.svg"
                class="icon s-16"
                aria-label="Supervisor"></svg-icon>
              {{ caseDetail.supervisorName }}
            </p>
          </div>
          <div class="content">
            <h4 class="title">Gender</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-male.svg"
                class="icon s-18"
                aria-label="Male"></svg-icon>
              {{ caseDetail.student.gender }}
            </p>
          </div>
        </div>
      </div>
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">Select the report you want to edit</h3>
      </div>
      <nz-table #basicTable [nzData]="reportList">
        <thead>
          <tr>
            <th scope="col" nzWidth="40px" nzAlign="center">Select</th>
            <th scope="col" nzWidth="200px">Report Name</th>
            <th scope="col" nzRight nzWidth="150px"></th>
          </tr>
        </thead>
        <tbody>
          @for (data of basicTable.data; track data) {
            <tr>
              <td nzWidth="40px" nzAlign="center">
                <nz-radio-group
                  id="report"
                  nzName="radiogroup"
                  [(ngModel)]="selectedReport"
                  [ngModelOptions]="{ standalone: true }">
                  <span nz-radio [nzValue]="data"></span>
                </nz-radio-group>
              </td>
              <td nzWidth="200px">{{ data.reportName }}</td>
              <td nzWidth="150px">
                <div class="action-btn-wrapper">
                  <button
                    type="button"
                    nz-button
                    nzType="default"
                    (click)="printReport(data)">
                    Download
                  </button>
                  <button
                    type="button"
                    nz-button
                    nzType="text"
                    class="primary-text-btn"
                    (click)="showDeleteReportModal(data.id)">
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
      <!-- Print/Edit an existing report end -->

      <div class="display-flex justify-content-between drawer-footer">
        <button nz-button type="button" nzType="default" (click)="onCancel()">
          Cancel
        </button>
        <div class="footer-right">
          <button
            nz-button
            type="button"
            nzType="primary"
            [disabled]="!selectedReport"
            (click)="onNext()">
            Next
          </button>
        </div>
      </div>
    </div>
  </form>
  <app-confirm-dialog
    [isVisible]="isDeleteVisible"
    [title]="'Are you sure?'"
    [message]="'Are you sure you want to delete this report?'"
    [iconSrc]="'/assets/icon/icon-trash-red.svg'"
    [iconColor]="'red'"
    [cancelText]="'Cancel'"
    [confirmText]="'Delete'"
    [loading]="isDeleting"
    (confirmed)="handleDelete()"
    (cancelled)="handleDeleteCancel()"
    (closed)="handleDeleteCancel()">
  </app-confirm-dialog>
</nz-spin>
<ng-template #editTpl>
  <app-drawer-header
    [title]="'Edit Report'"
    [subtitle]="'Edit Report'"
    breadcrumbText="{{ caseDetail.student.firstName }}'s"
    (drawerClose)="closeDrawer()">
  </app-drawer-header>
</ng-template>
